import $ from 'jquery'
window.$ = window.jQuery = $;
import 'bootstrap'
import 'lazysizes'
import Slick from './slick.js';
import menu from './menu.js';
import waitingDialog from './modal_dialog.js';
import exitintent from './jquery.exitintent.js';
import elevateZoom from './jquery.elevatezoom.js';
import customScripts from './custom-scripts.js';
import { partytownSnippet } from '@builder.io/partytown/integration';

const snippetText = partytownSnippet();
   